import script from "./how-its-work.vue?vue&type=script&setup=true&lang=js"
export * from "./how-its-work.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__